var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.7499C16.81 15.7499 16.62 15.6799 16.47 15.5299L12.92 11.9799L11.83 13.6199C11.71 13.8099 11.5 13.9299 11.28 13.9499C11.05 13.9699 10.83 13.8899 10.68 13.7299L7.47995 10.5299C7.18995 10.2399 7.18995 9.75994 7.47995 9.46994C7.76995 9.17994 8.24995 9.17994 8.53995 9.46994L11.09 12.0199L12.18 10.3799C12.3 10.1999 12.5 10.0799 12.73 10.0499C12.96 10.0299 13.18 10.1099 13.33 10.2699L17.53 14.4699C17.82 14.7599 17.82 15.2399 17.53 15.5299C17.38 15.6799 17.19 15.7499 17 15.7499Z",
    fill: "#F84C03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.75H15C14.59 15.75 14.25 15.41 14.25 15C14.25 14.59 14.59 14.25 15 14.25H16.25V13C16.25 12.59 16.59 12.25 17 12.25C17.41 12.25 17.75 12.59 17.75 13V15C17.75 15.41 17.41 15.75 17 15.75Z",
    fill: "#F84C03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/trend-down.71cd46f6ac354c3e729d6d8b9f2905ee.svg";
export { ForwardRef as ReactComponent };